// removed by extract-text-webpack-plugin
module.exports = {"related-story-image-container":"_3qs47","related-story-image":"_3Fzqk","project-title":"_3RcXS","avatar-container":"_3EaNq","avatar":"_3K749","card":"_1oq5r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlternativeProjects/RelatedStory.scss
// module id = ./src/components/AlternativeProjects/RelatedStory.scss
// module chunks = 5